module.exports = __webpack_public_path__ + "media/dm-print.c4c53495.svg";